var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6688 0.44557C7.28415 0.44557 7.75941 3.62609 7.75941 3.62609V6.95285H14.7785V7.97646H4.94446C4.94446 7.97646 0.228516 7.39154 0.228516 14.9224C0.228516 22.4533 4.3961 22.1243 4.3961 22.1243H6.8089V18.6148C6.8089 18.6148 6.66267 14.4472 10.8668 14.4472H17.8859C17.8859 14.4472 21.7976 14.5203 21.7976 10.6452V4.28413C21.8341 4.28413 22.4191 0.409012 14.6688 0.44557Z",
    fill: "url(#paint0_linear_1320_7598)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7939 2.67557C10.9622 2.66972 11.13 2.69734 11.2875 2.75683C11.4451 2.81631 11.5892 2.90648 11.7116 3.02209C11.8341 3.13771 11.9323 3.27649 12.0007 3.43036C12.0691 3.58424 12.1062 3.75017 12.11 3.91851C12.1197 4.25786 11.9942 4.58715 11.7611 4.83396C11.528 5.08077 11.2064 5.22487 10.867 5.23457C10.5277 5.24426 10.1984 5.11876 9.95154 4.88566C9.70473 4.65256 9.56062 4.33097 9.55093 3.99163C9.54586 3.65358 9.67292 3.3269 9.90507 3.08111C10.1372 2.83532 10.4561 2.68982 10.7939 2.67557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8879 29.3625C22.2726 29.3625 21.7973 26.1454 21.7973 26.1454V22.8553H14.7782V21.8316H24.6488C24.6488 21.8316 29.3648 22.3435 29.3648 14.9223C29.3648 7.50106 25.1972 7.72041 25.1972 7.72041H22.7478V11.1568C22.7478 11.1568 22.894 15.3244 18.6899 15.3244H11.6708C11.6708 15.3244 7.75917 15.2513 7.75917 19.1264V25.4874C7.75917 25.4874 7.17424 29.3625 14.8879 29.3625Z",
    fill: "url(#paint1_linear_1320_7598)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7628 27.1327C18.5134 27.1363 18.2685 27.0658 18.0591 26.9302C17.8497 26.7947 17.6853 26.6001 17.5865 26.371C17.4877 26.142 17.4591 25.8888 17.5042 25.6434C17.5493 25.3981 17.6662 25.1717 17.84 24.9928C18.0138 24.8139 18.2367 24.6905 18.4807 24.6383C18.7246 24.5861 18.9785 24.6074 19.2103 24.6995C19.4421 24.7916 19.6414 24.9503 19.783 25.1557C19.9246 25.361 20.0021 25.6038 20.0058 25.8532V25.8897C20.002 26.2182 19.8698 26.5321 19.6375 26.7644C19.4052 26.9967 19.0913 27.1289 18.7628 27.1327Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1320_7598",
    x1: -1.62862,
    y1: 23.9339,
    x2: 20.4596,
    y2: 1.84575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1320_7598",
    x1: 7.62756,
    y1: 28.4888,
    x2: 32.4356,
    y2: 6.78084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.729c0fdf70688820d1e7be141ebfd62e.svg";
export { ForwardRef as ReactComponent };